export default __webpack_public_path__ + "static/applet-12-set-1-9945d554afba52bcffe9eacae32763db.webp";